jQuery(function($){
    if ($('.nieuwsbrief__formulier').length == 0){
        return;
    }

    $('.nieuwsbrief__item').on('click', function(){

        var index = $(this).index();

        $('.nieuwsbrief__item').removeClass('active');
        $(this).addClass('active');

        $('.nieuwsbrief__formulier').removeClass('active');
        $('.nieuwsbrief__formulier').eq(index).addClass('active');

        let offset = $('.site-header__header').outerHeight(); 
        if ($('#wpadminbar').length > 0){
            offset += 32;
        }
        offset += 50;
        let offsetTop = $('.nieuwsbrief__formulier').eq(index).offset().top;

        window.scroll({
            top: offsetTop - offset, 
            behavior: "smooth" 
        });

    });


    

});